<template>
  <div v-if="visible" class="confirm-overlay">
    <div class="confirm-box">
      <div class="confirm-icon" :class="tipo">
        <i :class="icono"></i>
      </div>
      <h3 class="confirm-titulo">{{ titulo }}</h3>
      <p class="confirm-msg">{{ mensaje }}</p>
      <div class="confirm-btns">
        <button class="btn-cancel-c" @click="$emit('cancel')">{{ textoCancelar }}</button>
        <button class="btn-ok-c" :class="'btn-ok-' + tipo" @click="$emit('confirm')">{{ textoAceptar }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    visible:       { type: Boolean, default: false },
    titulo:        { type: String,  default: '¿Estás seguro?' },
    mensaje:       { type: String,  default: '' },
    tipo:          { type: String,  default: 'danger' },   // danger | warning | success
    textoAceptar:  { type: String,  default: 'Confirmar' },
    textoCancelar: { type: String,  default: 'Cancelar'  },
  },
  emits: ['confirm', 'cancel'],
  computed: {
    icono() {
      if (this.tipo === 'danger')  return 'bi bi-exclamation-triangle-fill';
      if (this.tipo === 'warning') return 'bi bi-exclamation-circle-fill';
      return 'bi bi-check-circle-fill';
    }
  }
};
</script>

<style scoped>
.confirm-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 99999; padding: 1rem;
  animation: fadeIn 0.15s ease;
}
@keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }

.confirm-box {
  background: white; border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  width: 100%; max-width: 400px;
  padding: 2rem 1.5rem 1.5rem;
  display: flex; flex-direction: column; align-items: center; gap: 12px;
  animation: slideUp 0.18s ease;
  font-family: "Montserrat", sans-serif;
}
@keyframes slideUp { from { transform: translateY(20px); opacity:0 } to { transform: translateY(0); opacity:1 } }

.confirm-icon {
  width: 56px; height: 56px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.6rem;
}
.confirm-icon.danger  { background: #fde8e8; color: #dc3545; }
.confirm-icon.warning { background: #fff8e1; color: #f59e0b; }
.confirm-icon.success { background: #d1fae5; color: #10b981; }

.confirm-titulo {
  font-size: 1rem; font-weight: 700; color: #1a1a1a;
  margin: 0; text-align: center;
}
.confirm-msg {
  font-size: 0.875rem; color: #6c757d; margin: 0;
  text-align: center; line-height: 1.5;
}
.confirm-btns {
  display: flex; gap: 10px; margin-top: 8px; width: 100%;
}
.btn-cancel-c {
  flex: 1; padding: 10px; border: 1px solid #dee2e6;
  background: white; color: #495057; border-radius: 10px;
  font-size: 0.875rem; font-weight: 600; cursor: pointer;
  font-family: "Montserrat", sans-serif; transition: all 0.2s;
}
.btn-cancel-c:hover { background: #f8f9fa; }

.btn-ok-c {
  flex: 1; padding: 10px; border: none; border-radius: 10px;
  font-size: 0.875rem; font-weight: 600; cursor: pointer;
  color: white; font-family: "Montserrat", sans-serif; transition: all 0.2s;
}
.btn-ok-danger  { background: #dc3545; }
.btn-ok-danger:hover  { background: #b02a37; }
.btn-ok-warning { background: #f59e0b; }
.btn-ok-warning:hover { background: #d97706; }
.btn-ok-success { background: #10b981; }
.btn-ok-success:hover { background: #059669; }
</style>
